<template>
    <section >
        <table class="table col-12">
            <tr class="divisor">
                <td>
                    <h6 class="p-1 text-dark label-table text-left ">
                        <b>Mantenimientos seleccionados: </b>
                    </h6>
                </td>
                <td>
                    <h6 class="p-1 text-dark label-table text-right">
                        <b>{{ contador }}</b>
                    </h6>
                </td>
            </tr>
            <tr class="bg-secondary divisor">
                <td>
                    <h6 class="p-1 text-dark label-table text-left ">
                        <b>Total mantenimientos: </b>
                    </h6>
                </td>
                <td>
                    <h6 class="p-1 text-dark label-table text-right">
                        <b>$ {{ sumaValue | puntos }}</b>
                    </h6>
                </td>
            </tr>
            <tr class="divisor">
                <td>
                    <h6 class="p-1 text-dark label-table text-left">
                    <b>Total descuento: </b>
                    </h6>
                </td>
                <td>
                    <h6 class="p-1 text-dark label-table text-right">
                        <b>$ {{ descuentos | puntos }}</b>
                    </h6>
                </td>
            </tr>
            <tr class="bg-secondary divisor">
                <td>
                    <h6 class="p-1 text-dark label-table text-left ">
                        <b>Subtotal: </b>
                    </h6>
                </td>
                <td>
                    <h6 class="p-1 text-dark label-table text-right">
                        <b>$ {{ subTotal | puntos }}</b>
                    </h6>
                </td>
            </tr>
            <tr class="divisor">
                <td>
                    <h6 class="p-1 text-dark label-table text-left ">
                        <b>IVA {{kilimetrajes}}%:</b>
                    </h6>
                </td>
                <td>
                    <h6 class="p-1 text-dark label-table text-right">
                        <b>$ {{iva | puntos}}</b>
                    </h6>
                </td>
            </tr>
        </table>
    </section>
</template>

<script>
import constantes from '../../constantes';

export default {
    name: "valoresDescuento",

    props: ['sumaValue', 'descuentos', 'iva', 'total', 'subTotal', 'contador', 'kilimetrajes'],

    filters: {
        puntos: (numero) => constantes.funciones.puntoMilesDecimal(numero),
    },

    watch: {
        descuentos: {
            immediate: true,
            handler(val, oldVal) { }
        },

        iva: {
            immediate: true,
            handler(val, oldVal) { }
        },

        total: {
            immediate: true,
            handler(val, oldVal) { }
        },

        subTotal: {
            immediate: true,
            handler(val, oldVal) { }
        },

        kilimetrajes: {
            immediate: true,
            handler(val, oldVal) { }
        },
    },
}

</script>

<style>
.modelo {
    margin-left: 1rem;
    margin-bottom: 1rem;
    margin-top: 1rem;
}

.margenes {
    width: 90%;
    padding-right: 10px;
    padding-left: 10px;
    margin-right: auto;
    margin-left: auto;
    border-bottom: solid;
    border-bottom-color: #ffffff;
    border-bottom-width: 2.5px;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
    background-color: #dbd7d7
}

.justificado {
    display: flex;
    justify-content: flex-end
}

.justificadoTotal {
    font-size: 16px;
    color: #8d2c2c;
    display: flex;
    justify-content: flex-end;
}

.spaceBetween {
    padding: 1%;
    display: flex;
    justify-content: space-between;
}

.divisor{
    border-bottom: rgb(215, 209, 209) solid;
    border-bottom-width: thin;
}
</style>
